import { o2a } from '..'
import _ from 'lodash'

const dupName = (arr) => {
	const t = {}
	for (const a of arr) {
		if (t[a.name])
			return a.name
		t[a.name] = a
	}
	return undefined
}

/**
 * 设置Tyan.menus, 并
 * 1、计算allPaths
 * 2、检查Tasks
 * @param {*} allMenus 
 * @param {*} allRoles 
 * @param {*} allTasks 
 * @param {*} pageRoutes 
 */

const _setMenus = (allMenus, allRoles, allTasks, pageRoutes) => {

	/** 
	 * 生成allPaths,增加title属性，同时检查path是否重复
	 */
	const allPaths = {}

	const allComps = []

	allMenus && (function getPaths(menus, preTitle) {
		for (const [t, m] of Object.entries(menus)) {
			if (m._path) {
				if (allPaths[m._path])
					throw `重复 path '${m._path}' in "${preTitle}${t}"`
				// 在menu中写入菜单全名，并根据allRoles生成对应的roles数据
				m.fullName = `${preTitle}${t}`
				m.preName = preTitle ? preTitle.substring(0, preTitle.length - 1) : preTitle
				m.roles = [], allRoles && Object.entries(allRoles).forEach(([r, { 菜单: ms }]) => ms && ms.includes(m.fullName) && m.roles.push(r))
				allPaths[m._path] = m

				m._title = t
			} else if (m._icon) {
				getPaths(m, `${preTitle}${t}.`)
			}
		}
	})(allMenus, '')

	/**
	 *checkTasks 检查allTasks并增加config
	 *  1、检查点
	 *    1) 任务名称(key) 不能重复
	 *    2) 每个任务的所有path必须在allPaths存在，以判断权限 (?? 可以不在allPaths中，不判断权限？)
	 *    3) 每个任务的第一个path在allPaths中必须存在component并且能成功从中读取config信息Every task's first path have component and get config from the component
	 *  2、const allTasks = {
	 *    任务名称：[   // 显示在任务切换按钮上
	 *      {
	 *        path:path,    // 必须项：在allMenus中的_path中存在, 其中每一个任务的第一项配置要能从allMenus相应条目的_component中读取到config属性
	 *        tabs:[tab1, tab2]，// 可选项，如为第一个path，如无tabs，则取config或config.tabs[0]；不为第一项，则仅作为从后台取数据时使用
	 *      }
	 *      config:使用其中的列项配置以及onChildDoubleTap
	 *    ]
	 *  }
	 */
	allTasks && (function checkTasks() {
		const newTasks = []
		for (const [taskName, task] of Object.entries(allTasks)) {
			if (!task.length) {
				console.debug(`任务'${taskName}'无配置项`)
				delete allTasks[taskName]
				continue
			}
			// 生成config
			// for (const pathDef of task) {
			//   const menu = allPaths[pathDef.path]
			//   if (!menu)
			//     throw `任务'${taskName}'的路径'$pathDef.path'不存在`
			//   }
			// }
			let iPath = 0
			const newTask = { name: taskName, tabs: [] }
			for (const pathDef of task) {
				iPath++

				if (!pathDef.path)
					throw `任务'${taskName}'中第${iPath}项配置无路径信息`
				if (!allPaths[pathDef.path])
					throw `任务'${taskName}'中第${iPath}个路径'${pathDef.path}'在菜单中不存在`
				if (!allPaths[pathDef.path]._component)
					throw `任务'${taskName}'中第${iPath}个路径'${pathDef.path}'在菜单定义中无组件定义用于读取列项信息`

				// pathDef.preName = allPaths[pathDef.path].preName

				let comp = null
				try {
					comp = new allPaths[pathDef.path]._component
					if (!comp.type.name.includes('Manage'))
						comp = new comp.type(comp.props)
				} catch (e) {
					comp = null
				}

				if (!comp || !comp.props || !comp.props.config)
					throw `任务'${taskName}'中第${iPath}个路径'${pathDef.path}'的组件配置不正确，无法读到config信息`

				let config = comp.props.config
				config = typeof config == 'function' ? config(comp.props) : config
				if (pathDef.tabs && !config.tabs)
					throw `任务'${taskName}'中第${iPath}个路径'${pathDef.path}'配置了tabs, 但组件中未配置tabs`
				if (!config.tabs) {
					newTask.tabs.push({
						name: pathDef.name || allPaths[pathDef.path].preName || allPaths[pathDef.path].fullName,
						path: pathDef.path,
						config: config,
						tab: ''
					})
				} else {
					for (const tab of (pathDef.tabs || Object.keys(config.tabs))) {
						if (!config.tabs[tab])
							throw `任务'${taskName}'中第${iPath}个路径'${pathDef.path}'配置的tab '${tab}' 在组件配置中不存在`
						newTask.tabs.push({
							// name: `${pathDef.name || allPaths[pathDef.path].preName || allPaths[pathDef.path].fullName}${pathDef.tabs.length > 1 ? `.${tab}` : ''}`,
							name: pathDef.name === '' ? `${tab}` : `${pathDef.name || allPaths[pathDef.path].preName || allPaths[pathDef.path].fullName}${pathDef.tabs.length > 1 ? `.${tab}` : ''}`,
							path: pathDef.path,
							config: config.tabs[tab],
							tab
						})
					}
				}
				// if (!pathDef._tabs.length)
				//   throw `任务'${taskName}'中第${iPath}个路径'${pathDef.path}'的组件配置不正确，无法读到config信息`
			}
			if (dupName(newTask.tabs))
				throw `任务'${taskName}'发现重名'${dupName(newTask.tabs)}'`

			newTask.tabs.length && newTasks.push(newTask)
		}
		// if (dupName(newTasks))
		//   throw `发现重名任务'${dupName(newTasks)}'`
		allTasks = newTasks
	})()
	// console.log('allTasks:', allTasks)

	Tyan.menus.allMenu = allMenus || {}
	Tyan.menus.allPaths = allPaths || {}
	Tyan.menus.allRoles = allRoles || {}
	Tyan.menus.allTasks = allTasks || {}
	Tyan.menus.pageRoutes = pageRoutes || []
}

export const setMenus = (...args) => {
	if (!Tyan.menus.version)
		throw '在调用setMenus之前请先设置Tyan.menus.version'

	// version >= 5 由修改为菜单、角色等定义由后台处理
	if (Tyan.menus.version >= 5) {
		console.error('Tyan.menus.version >=5 时 setMenus 不能使用')
		return
	}
	_setMenus(...args)
}

// 用于Tyan.menus.version === 5，生成allMenus调用_setMenus，并返回privateMenu
export const setMenus5 = (menu) => {
	const genMenu = menu => {
		const all = {}
		menu.forEach(({ text, icon, path, component, items, ...rest }) => {
			if (!component && !items) return
			// icon = icon || (component ? '' : '')
			const curr = all[text] = { _icon: icon, ...rest }
			if (component) {
				curr._path = path
				if (!(curr._component = Tyan.menuComponents[component])) {
					delete all[text]
					console.error(`菜单组件 ${component} 不存在`, { text, icon, path, component, items, ...rest })
					return
				}
			} else {
				path && (curr._group = path)
				all[text] = { ...curr, ...genMenu(items) }
			}
		})

		return all
	}

	const allMenu = genMenu(menu || [])
	// console.log('allMenu:', menu, allMenu)
	_setMenus(allMenu)
	const privateMenu = Object.values(Tyan.menus.allPaths || {}).map(({ _path }) => _path)
	// console.log('privateMenu:', privateMenu)
	return privateMenu
}


const getMenuByFullname = fullname => {
	const arr = fullname.split('.')
	let m = Tyan.menus.allMenu
	arr.forEach(o => m = m && m[o])
	return m && m._path
}

export const getMenuByRoles = roles => roles && roles.reduce((menus, role) => {
	const roleMenus = Tyan.menus.allRoles[role]
	roleMenus && roleMenus.菜单 && roleMenus.菜单.map(o => getMenuByFullname(o)).filter(o => o).forEach(o => !menus.includes(o) && menus.push(o))
	return menus
}, []) || []


const _getMenus = privateMenu => (menu, init = { name: '' }, lastGroup = '') => {
	const { token, authType } = Tyan.loginInfo || {}
	const isAuth = authType === 'auth'

	return Object.entries(menu).filter(([key]) => key[0] != '_').reduce((ret, [key, curr], index) => {
		// const curr = menu[key]
		ret.children || (ret.children = [])

		if (isAuth && key === '修改密码') return ret
		// 隐藏菜单
		if (curr._hidden) return ret

		const { _path, _group, _public, _notLogin, _icon } = curr
		if (_path) {
			if (Tyan.sysMode === 'sample'
				|| privateMenu && privateMenu.includes(Tyan.menus.version > 1 ? _path : key)
				|| _public
				|| (!token && _notLogin)
			)
				ret.children.push({ id: _path, leaf: true, name: Tyan.t(key, 'nav'), text: Tyan.t(key, 'nav'), iconCls: _icon && 'x-fa fa-' + _icon || undefined })
		} else {
			const id = _group || `${lastGroup}/${key}`
			let subMenu = { id, leaf: false, name: Tyan.t(key, 'nav'), text: Tyan.t(key, 'nav'), iconCls: _icon && 'x-fa fa-' + _icon || undefined }
			subMenu = _getMenus(privateMenu)(curr, subMenu, id)
			subMenu.children && subMenu.children.length && ret.children.push(subMenu)
		}
		return ret
	}, init)
}

export const getMenus = privateMenu => {
	return _getMenus(privateMenu)(Tyan.menus.allMenu)
}

export const getRoutes = privateMenu => {
	const { token, authType } = Tyan.loginInfo || {}
	const isAuth = authType === 'auth'

	// const allPaths = Tyan.menus.allPaths
	// console.log('allPaths:', Tyan.menus.allPaths)
	const routes = Object.entries(Tyan.menus.allPaths).reduce((ret, [path, curr]) => {
		// const curr = allPaths[path]
		if (isAuth && curr._title === '修改密码') return ret
		// 隐藏菜单不生成Route
		if (curr._hidden) return ret
		if (Tyan.sysMode === 'sample' || privateMenu && privateMenu.includes(Tyan.menus.version > 1 ? path : curr._title) || curr._public || (!token && curr._notLogin))
			ret[path] = { title: curr._title, component: curr._component, props: curr.props }
		return ret
	}, {})
	return o2a(routes, 'path').concat(Tyan.menus.pageRoutes)
}


/**
 * getTasks: 根据用户权限返回有效tasks
 */
export const getTasks = _.memoize(privateMenu => {
	const allTasks = Tyan.menus.allTasks
	const allPaths = Tyan.menus.allPaths
	return allTasks.reduce((ret, task) => {
		const newTask = task.tabs.reduce((s, tab) => {
			if (privateMenu && privateMenu.includes(tab.path) || !allPaths[tab.path] || allPaths[tab.path]._public)
				s.tabs.push(tab)
			return s
		}, { name: task.name, tabs: [] })
		Object.keys(newTask.tabs).length && ret.push(newTask)

		return ret
	}, [])
})
